import { useGenUiConfig } from './config.js';

/**
 * Port de telemetria de produto, injetado pelo host via `GenUiConfigProvider`
 * (mesmo padrão dos demais ports do kit). O kit nunca importa um SDK de
 * analytics: só emite `track(name, props)` — o host decide o transporte
 * (fila local, chamada de rede, etc.) e o REGISTRY que valida `name`/`props`
 * vive no domain, não aqui.
 */
export interface GenUiTelemetryPort {
  track(name: string, props?: Record<string, string | number | boolean>): void;
}

const NOOP: GenUiTelemetryPort = { track: () => undefined };

/** Fail-soft: sem port injetado, nada emite (contrato de ports do kit). */
export function useGenUiTelemetry(): GenUiTelemetryPort {
  return useGenUiConfig().telemetry ?? NOOP;
}
